import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { fidelizacao } from "../../services/api";

const Fidelizacao_pizza = (props) => {

    const [data2, setData2] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await fidelizacao(data_inicio, data_fim);
            console.log("fid", response)
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("data2", data2);

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    let tpr = 0;
    let trn = 0;

    let chartDataFid = [];

    if (typeof data2 !== 'undefined') {
        chartDataFid = data2.map((item, index) => {
            const row = [unidades[parseInt(item.sec)]];
            row.push(item.pr || 0);
            row.push(item.rn || 0);
            row.push(item.rnp || 0);
            row.push(item.evp || 0);
            tpr += parseInt(item.pr);
            trn += parseInt(item.rn);
            return row;
        });

    }

    let chartDataFidPizza = [];
    chartDataFidPizza.push(['Tipo', "Alunos"])
    chartDataFidPizza.push(["Evasão", tpr - trn]);
    chartDataFidPizza.push(["Renovados", trn]);

    console.log("chartDataFidPizza", chartDataFidPizza)

    const options = {
        title: "Evasão e Fidelização",
        titleTextStyle: { color: 'black', fontSize: '15' },
        legend: { position: 'top', maxLines: 2, textStyle: { fontSize: '11' } },
        width: 350,
        height: 250,
        pieSliceText: 'value',
        pieSliceTextStyle: { fontSize: '14' }
    };


    return (
        <div className="bolsas">
            <Chart
                chartType="PieChart"
                version="current"
                data={chartDataFidPizza}
                options={options}
                width={"100%"}
            />
        </div>
    );
};
export default Fidelizacao_pizza;